import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { addToLocal } from '../../../services/localStorageService'
import Layout from '../../common/layout/layout'

function Language() {
  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col lg={12}>
              <h1 className="pageTitle">Choose a language</h1>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col
              lg={8}
              className="mx-auto"
              onClick={() => addToLocal('language', 'tagalog')}
            >
              <Link to="/" className="flagItem">
                <Row className="align-v-center">
                  <Col xs={3} sm={2}>
                    <img
                      src="/icons/flag-philippines.svg"
                      alt="Philippines flag"
                    />
                  </Col>
                  <Col xs={9} sm={10}>
                    Tagalog
                  </Col>
                </Row>
              </Link>
            </Col>
          </Row>
          <Row>
            <Col
              lg={8}
              className="mx-auto"
              onClick={() => addToLocal('language', 'bahasa')}
            >
              <Link to="/" className="flagItem">
                <Row className="align-v-center">
                  <Col xs={3} sm={2}>
                    <img src="/icons/flag-indonesia.svg" alt="Indonesia flag" />
                  </Col>
                  <Col xs={9} sm={10}>
                    Bahasa Indonesia
                  </Col>
                </Row>
              </Link>
            </Col>
          </Row>
          <Row>
            <Col
              lg={8}
              className="mx-auto"
              onClick={() => addToLocal('language', 'english')}
            >
              <Link to="/" className="flagItem">
                <Row className="align-v-center">
                  <Col xs={3} sm={2}>
                    <img src="/icons/flag-uk.svg" alt="UK flag" />
                  </Col>
                  <Col xs={9} sm={10}>
                    English
                  </Col>
                </Row>
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout>
  )
}

export default Language
